module.exports = __webpack_public_path__ + "../resources/img/install_img.92c1fa11.png";